import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ScopeProvider } from 'app/upgraded.providers';

@Directive({
  selector: 'app-schedule',
  providers: [ScopeProvider],
})
export class ScheduleUpgradeDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('scheduleDirective', elementRef, injector);
  }
}
